export default __webpack_public_path__ + "static/media/fuji_xt20.463dcbbc.png";